


























































import { Component, Vue, Prop } from "vue-property-decorator";
import Empty from "@/components/empty.vue";
import Tiwen from "@/components/qa/tiwen.vue";
import QaCell from "@/components/qa/qa-cell.vue";
import { EditQA, GetQaList } from "@/request/common";
@Component({
  components: {
    Tiwen,
    QaCell,
    Empty,
  },
})
export default class Name extends Vue {
  private detail: any = { pic_list: [] };
  private data: any = {};
  private qaTab: any = "全部";
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private updateData(d: any) {
    this.detail = d;
  }
  private changeQaTab(item: any) {
    this.qaTab = item;
    this.getData();
  }
  private sure() {
    if (!this.detail["名称"]) {
      this.$message.warning("请输入问题名称!");
      return;
    }
    // if (this.detail.pic_list.length == 0) {
    //   this.$message.warning("请上传图片!");
    //   return;
    // }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (!this.detail.asker_id) {
      this.detail.asker_id = this.user.user_id;
    }
    if (!this.detail.banji_id) {
      this.detail.banji_id = this.user["所属班级"].banji_id;
    }
    EditQA(this, this.detail, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("提问成功");
        this.detail = { pic_list: [] };
        this.getData();
      })
      .catch(() => {
        loading.close();
      });
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      current_page: 1,
      page_count: 0,
      状态: this.qaTab == "全部" ? "全部" : this.qaTab,
    };
    GetQaList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    this.getData();
  }
}
